export const sortElementsByOrder = <T = any[]>(elements: T): T => {
  return Array.isArray(elements)
    ? elements.sort((e1: any, e2: any) => {
        return typeof e1.order === 'number' && typeof e2.order === 'number'
          ? e1.order - e2.order
          : 0;
      })
    : elements;
};
